import styled, { DefaultTheme, ThemeProps } from 'styled-components';
import { getSpacingToken, getToken } from '@optimus-web/common';
import { Stack } from '../Stack';
import { SegmentedControlProps } from './types';

type SegmentedControlStackProps = Pick<SegmentedControlProps, 'size' | 'vertical'>;

const getHeight = ({ size, vertical, theme }: SegmentedControlStackProps & ThemeProps<DefaultTheme>) => {
    if (vertical) {
        return 'auto';
    }

    let height = getToken('sizing500');
    switch (size) {
        case 'small':
            height = getToken('sizing400');
            break;
        case 'medium':
            height = getToken('sizing500');
            break;
        case 'large':
            height = getToken('sizing600');
            break;
        case 'extraLarge':
            height = getToken('sizing700');
            break;
        default:
            height = getToken('sizing500');
            break;
    }

    return `${height({ theme })}px`;
};

export const SegmentedControlStack = styled(Stack)<SegmentedControlStackProps>`
    background-color: ${getToken('backgroundInteractiveNeutralDefault')};
    border-radius: ${getToken('borderRadius100')}px;
    height: ${getHeight};
    padding: ${getSpacingToken('25')}px;
    box-sizing: border-box;
`;
